import Aos from "aos";
import "aos/dist/aos";
import React, { useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import featuredOne from "../../../Images/Featured/banner-01.webp";
import featuredTwo from "../../../Images/Featured/banner-02.webp";
import featuredThree from "../../../Images/Featured/banner-03.webp";
import featuredFour from "../../../Images/Featured/banner-04.webp";
import "./Featured.css";

const Featured = () => {
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);
  return (
    <section className="featured overflow-hidden">
      <Container>
        <Row className="my-5">
          <Col md={3} sm={12} xs={12}>
            <img
              data-aos="zoom-in"
              className="w-100 featured-img"
              src={featuredOne}
              alt=""
            />
          </Col>
          <Col md={3} sm={12} xs={12}>
            <img
              data-aos="zoom-in"
              className="w-100 featured-img"
              src={featuredTwo}
              alt=""
            />
          </Col>
          <Col md={3} sm={12} xs={12}>
            <img
              data-aos="zoom-in"
              className="w-100 featured-img"
              src={featuredThree}
              alt=""
            />
          </Col>
          <Col md={3} sm={12} xs={12}>
            <img
              data-aos="zoom-in"
              className="w-100 featured-img"
              src={featuredFour}
              alt=""
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Featured;
